<template>
  <div class="loc-wrap">
    <label for="state">Select State</label>
    <div class="select-wrap">
      <select name="state" id="state" @change="findCities($event)">
        <option value="">-- Select State --</option>
        <option :value="state" v-for="(state, i) in setStates" :key="i">{{state}}</option>
      </select>
    </div>
    <!-- <div class="select-wrap" v-if="cities.length > 1">
      <select name="city" id="city" @change="findStores($event)">
        <option value="">-- All Cities --</option>
        <option :value="city" v-for="(city, i) in cities" :key="i">{{city}}</option>
      </select>
    </div> -->
    <div class="results">
      <!-- <h3>{{state}}</h3> -->
      <div class="res-loop" v-for="(store, index) in stores" :key="index">
        <div class="city">
          <h4>{{store.City}}</h4>
        </div>
        <div class="loc">
          <ul v-for="(location, i) in store.Locations" :key="i" :class="i > 0 ? 'multi' : ''">
            <li class="name">{{location.displayName}}</li>
            <li class="address">
              <a target="_blank" :href="`https://www.google.com/maps/place/${location.displayAddress1},+${location.displayCity},+${location.displayState}+${location.displayZIP}`">
                {{location.displayAddress1}}
                <br v-if="location.displayAddress2">{{location.displayAddress2}}
                <br v-if="location.displayAddress3">{{location.displayAddress3}}
                <br>{{location.displayCity}}, {{location.displayState}} {{location.displayZIP}}
              </a>
            </li>
            <li class="phone" v-if="location.displayPhone"><a :href="`tel:${location.displayPhone}`">{{location.displayPhone}}</a></li>
            <li class="phone" v-if="location.displayPhone2"><a :href="`tel:${location.displayPhone2}`">{{location.displayPhone2}}</a></li>
            <li class="email" v-if="location.displayEmail"><a :href="`mailto:${location.displayEmail}`">{{location.displayEmail}}</a></li>
            <li class="website" v-if="location.displayWebsite"><a :href="location.displayWebsite" target="_blank">Website</a></li>
            <li v-if="location.doesInstallations" class="installs">Installation available. Fee may apply.</li>
            <li v-if="location.displayNote">{{location.displayNote}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import axios from 'axios'

  export default {
    name: 'Home',
    data() {
      return {
        theData: [],
        states: [],
        state: '',
        theCities: [],
        cities: [],
        stores: []
      }
    },
    computed: {
      setStates() {
        return [...new Set(this.states)]
      }
    },
    methods: {
      getLocations() {
        axios.get('https://rufftuffdata.net:8084/retaillocation/all')
        .then((res) => {
          this.theData = res.data
          for(let i = 0, l = this.theData.length; i < l; i++) {
            this.states.push(this.theData[i].displayState)
          }
        })
        .catch(error => console.log(error));
      },
      findCities(event) {
        if (!event.target.value) {
          this.cities = []
          this.stores = []
          return
        } else {
          this.cities = []
          this.stores = []
          this.state = event.target.value
          axios.get(`https://rufftuffdata.net:8084/retaillocation/state/${event.target.value}/locationsbycity`)
          .then((res) => {
            this.theCities = res.data
            for(let i = 0, l = this.theCities.length; i < l; i++) {
              this.cities.push(this.theCities[i].City)
              this.stores.push(this.theCities[i])
            }
          })
          .catch(error => console.log(error));
        }
      },
      findStores() {

      }
    },
    mounted() {
      this.getLocations()
    }
  }
</script>

<style lang="scss">
*,
*::before,
*::after {
  box-sizing: border-box;
  font-family: 'Open Sans', sans-serif;
  // color: #444441;
}
.loc-wrap {
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;

  label {
    display: block;
    max-width: 99%;
    width: 100%;
    margin: 0 auto;
    padding: 15px 0 5px;
  }

  .res-loop {
    display: flex;
    flex-flow: row wrap;
    padding: 15px 0;
    &:nth-child(odd) {
      background-color: #f5f5f5;
    }
  }

  .select-wrap {
    max-width: 100%;
    text-align: center;
    overflow: hidden;
    margin: 0 auto 50px;
    width: 100%;
    border: 1px solid var(--select-border);
    border-radius: 0.25em;
    font-size: 1.25rem;
    cursor: pointer;
    line-height: 1.1;
    background-color: #e5e5e5;
    position: relative;
    padding: 0 12px;

    &::after {
      content: '';
      width: 0; 
      height: 0; 
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 15px solid #a51e23;
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      z-index: 1;
    }

    select {
      appearance: none;
      background-color: transparent;
      border: none;
      padding: 0;
      margin: 0;
      width: 106%;
      height: 55px;
      font-family: inherit;
      font-size: inherit;
      cursor: inherit;
      line-height: inherit;
      outline: none;  
      box-shadow: none !important;
      position: relative;
      z-index: 2;
    }
  }

  .city {
    flex: 0 0 100%;

    @media screen and (min-width: 640px) {
      flex: 0 0 20%;  
    }
  }

  h4 {
    margin: 0 0 15px 15px;
    font-size: 20px;
  }

  ul {
    margin: 0 0 0 15px;
    padding: 0;
    list-style: none;

    li {
      padding-bottom: 5px;
      &.name {
        font-size: 18px;
        font-weight: 700;
        color: #a51e23;
        margin-bottom: 5px;
      }

      &.address {
        position: relative;
        padding-left: 25px;

        &::before {
          font-family: "Font Awesome 5 Pro";
          content: "\f3c5";
          color: #a51e23;
          position: absolute;
          left: 0;
          top: 1px;
        }
      }

      &.phone {
        position: relative;
        padding-left: 25px;

        &::before {
          font-family: "Font Awesome 5 Pro";
          content: "\f095";
          color: #a51e23;
          position: absolute;
          left: 0;
          top: 0;
        }
      }

      &.email {
        position: relative;
        padding-left: 25px;

        &::before {
          font-family: "Font Awesome 5 Pro";
          content: "\f0e0";
          color: #a51e23;
          position: absolute;
          left: 0;
          top: 5px;
        }
      }

      &.website {
        position: relative;
        padding-left: 25px;

        &::before {
          font-family: "Font Awesome 5 Pro";
          content: "\f08e";
          color: #a51e23;
          position: absolute;
          left: 0;
          top: 2px;
        }

        a {
          font-size: 13px;
          color: #a51e23;
          text-decoration: underline;
        }
      }

      a {
        text-decoration: none;
        color: #444441;
      }
    }

    &.multi {
      margin-top: 15px;
    }
  }
}
</style>
